// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__1zoq5"};